import {AfterViewInit, Component, Inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {NgbCollapseModule} from '@ng-bootstrap/ng-bootstrap';
import jQuery from 'jquery'
import {isPlatformBrowser, NgIf} from '@angular/common';
import {Router, RouterLink, RouterLinkActive} from '@angular/router';
import {AuthService} from '../../services/auth.service';
import {User} from '../../models/user';
import {firstValueFrom, Subject, takeUntil} from 'rxjs';
import {CompanyService} from '../../services/company.service';
import {Company} from '../../models/company';

@Component({
  selector: 'app-header',
  imports: [NgbCollapseModule, NgIf, RouterLink, RouterLinkActive],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit {
  onDestroy$ = new Subject<boolean>();

  isLoggedIn = false;
  isAdmin = false;
  isShareholder = false;
  isMerchant = false;
  isCustomer = false;
  isCustomerTeam = false;
  isCustomerAffiliate = false;

  // User
  currentUser: User | null = null

  // Companies
  companies: Company[] = []

  isUnreadIndicator = false;
  isUnreadCommunity = false;

  isActiveVisit = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object,
              private router: Router,
              private authService: AuthService,
              private companyService: CompanyService) {
  }

  ngOnInit() {
    this.authService.currentUser$.pipe(takeUntil(this.onDestroy$)).subscribe(currentUser => {
      this.handleCurrentUser(currentUser).finally()
    })
  }

  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  ngAfterViewInit() {

    // Hide the navbar dropdown if it's shown
    if (isPlatformBrowser(this.platformId)) {
      jQuery(document).ready(() => {
        jQuery(document).unbind("click")
        jQuery(document).click((event: any) => {
          let isNotClickOnNavbar = !jQuery(event.target).hasClass("navbar")
          let isNavbarOpened = jQuery(".navbar-collapse").hasClass("show")
          if (isNotClickOnNavbar && isNavbarOpened) {
            jQuery(".navbar-collapse").removeClass("show")
          }
        });
      });
    }
  }

  async handleCurrentUser(currentUser: User) {

    // Logged in
    if (currentUser) {
      this.currentUser = currentUser

      // Check to see if the user is part of a company leader
      this.companies = await this.refreshCompaniesPromise()

      this.isLoggedIn = true;
      this.isAdmin = currentUser.role === 'admin'
      this.isShareholder = currentUser.role === 'shareholder'
      this.isMerchant = currentUser.role === 'merchant'
      this.isCustomer = currentUser.role === 'customer'
      this.isCustomerTeam = this.companies.length > 0
      this.isCustomerAffiliate = currentUser.preference?.allowAffiliate || false
      this.isUnreadIndicator = false; // TODO
      this.isUnreadCommunity = false; // TODO
      this.isActiveVisit = false; // TODO

    } else {

      // Not logged in
      this.isLoggedIn = false;
      this.isAdmin = false;
      this.isShareholder = false;
      this.isMerchant = false;
      this.isCustomer = false;
      this.isCustomerTeam = false;
      this.isCustomerAffiliate = false;
      this.isUnreadIndicator = false;
      this.isUnreadCommunity = false;
      this.isActiveVisit = false;
    }

  }

  async refreshCompaniesPromise() {
    if (!this.currentUser) return Promise.resolve([])
    if (!this.currentUser.company) return Promise.resolve([])

    return firstValueFrom(this.companyService.findByUser().pipe(takeUntil(this.onDestroy$)), {defaultValue: []})
  }

  logout() {
    this.authService.logout();
    this.router.navigate(["/login"]).finally()
  }

}
